/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import axios from 'axios';

import React,{ useEffect, useState, useRef } from 'react';
import { connect, useSelector } from 'react-redux';
import { Button, Overlay, OverlayTrigger, Popover, Form } from 'react-bootstrap';

import store from 'features/store'; 
import {biddernotificationList, notificationSseEvent, updateNotication } from './../../../../shared/settings/apiconfig';
import { getBuyersUrl, getBuyerHeaders, getPaymentUrl } from './../../../../shared/http';
import { addDataLayer } from 'shared/utils/utils';
import { NavigationBarHOC } from 'shared/hoc/navigation/NavigationBarHOC';
import { MenuItemInput } from 'shared/hoc/form/FormInput';
import { arrowDown, bell, eye, filter, hammer, searchIcon,notidicationCloseIcon } from 'shared/assets/icons';
import { Accordion } from 'shared/hoc/accordion/Accordion';
import { SearchAccordion } from 'shared/hoc/accordion/searchAccordion';
import { resetBreadcrumbs } from 'shared/hoc/breadcrumbs/Breadcrumbs';

import './Header.scss';

const ProfileSection = ({props, user}) => {

    return (
        <div role='button' className="d-flex align-items-center gap-2" style={{backgroundColor : props.location.pathname.includes('/my-account') &&  '#868E961F', padding: props.location.pathname.includes('/my-account') &&  '2px 9px',}}>
            <div className='profile-avatar'>
                {
                    user.profileImage ?
                        <img src={user.profileImage} alt="profile-image" style={{width: '100%', height: '100%'}}  /> :
                        <img src={process.env.PUBLIC_URL + '/static/icons/profile/default_1.svg'} alt="profile-image" style={{width: '100%', height: '100%'}} />
                }
            </div>
            <div className='profile-names' style={{ color : props.location.pathname.includes('/my-account') && '#A50050' }}>
                {(user.lastName ? user.lastName + ', ' : '') + (user.firstName ? user.firstName : '')}
            </div>
        </div>
    );
};

const profileMenuItem = {
    icon: <></>,
    items: [
        {
            id: 1,
            label: 'My Account',
            type: 'link',
            redirectTo: '/my-account/my-info/personal-info'
        },
        {
            id: 2,
            label: 'FAQ',
            type: 'link',
            redirectTo: '/help/faq'
        },
        {
            id: 3,
            label: 'Invoices / Receipts',
            type: 'link',
            redirectTo: '/my-account/invoice'
        }
    ],
    footer: [
        {
            id: 4,
            label: 'Sell with us',
            type: 'external-link',
            openUrl: 'https://www.caringtransitions.com/two-ways-to-sell'
        },
        {
            id: 5,
            label: 'Sign Out',
            type: 'modal'
        }
    ],
};

let eventSource = null;

export const Header = (props) => {
  
    const reduxState = useSelector(state => state);

    useEffect(() => {
        const current_path = props.location.pathname;
        const check = current_path.includes('view-more-items') ? current_path.split('/').length === 3 : false;
        if (check) {
            setSearchValue(props.location.searchValue || searchValue);
        } else {
            setSearchValue('');
        }
    }, [props.location.pathname])

    const getPrimaryMenus = () => {
        return [
            { id: 1, label: 'Estate Sales', type: 'link', redirectTo: '/estate-sale/list', active: false },
            { id: 2, label: 'Categories', type: 'category-menu', icon: arrowDown, active: false, items: reduxState.category },
            { id: 3, label: 'Explore', type: 'modal', icon: filter, active: false,  action: () => { openModal() }, dataLayer: 'explore_listing' }
        ];
    };

    const getSecondaryMenus = () => {
        return [
            { id: 3, label: 'Locations', type: 'link', redirectTo: '/locations', active: false, dataLayer: 'locations' },
            { id: 4, label: 'Ending Soon', type: 'link', redirectTo: '/estate-sale/list/endingsoon', active: false, dataLayer: 'ending_soon' },
            { id: 5, label: 'About Us', type: 'link', redirectTo: '/about', active: false, dataLayer: 'about_us' },
            { id: 6, label: 'FAQ', type: 'link', redirectTo: '/help/faq', active: false, dataLayer: 'faq' },
            { id: 7, label: 'Premier Membership', type: 'link', redirectTo: '/premier-membership', active: false, showOrHide: validateNonMembership, dataLayer: 'premier_membership' },
            { id: 8, label: 'Your Premier Membership', type: 'link', include: '/premier-membership', redirectTo: '/my-account/premier/member-benefits', showOrHide: validateMembershipCompleted, dataLayer: 'your_premier_membership' },
            { id: 9, label: 'News and Stories', type: 'link', redirectTo: '/stories', active: false, dataLayer: 'news_stories' },
            { id: 10, label: 'Sell with Us', type: 'external-link', redirectTo: '', active: false, openUrl: 'https://www.caringtransitions.com/two-ways-to-sell', icon: true, dataLayer: 'sell_ctbids' },
            // { label: 'Become our Caring Partner', type: 'external-link', redirectTo: '', active: false,  openUrl: 'https://www.caringtransitionsfranchise.com/' }
        ];
    };

    const smallMenuActionCallback = (menu) => {
        switch (menu.label) {
            case 'Sign In': 
                store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: 'Sign-In' } });
                break;
            case 'Register':
                store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: 'Sign-Up' } });
                break;
            case 'Sign Out':
                store.dispatch({ type: 'TOGGLE_LOGOUT_MODAL', payload: true });
                break;
            default:
                break;
        }
    };
    const openModal = () =>{
        store.dispatch({
            type: 'PUSH_TO_STATE', payload: {}
        });
        store.dispatch({ type: 'EXPLORE_MODAL', payload: !reduxState?.exploreModal });
    }
    const validateSignedIn = (user) => {
        return Boolean(user.id) === true;
    };

    const validateNotSignedIn = (user) => {
        return Boolean(user.id) === false;
    };

    const validateMembershipCompleted = (user) => {
        return user.id && user.membershipCompleted === 1;
    };

    const validateNonMembership = (user) => {
        return user.membershipCompleted != 1;
    };

    const validateRegister = (user) =>{
        return  !user.id
    }
    const onClickMenuItem = (menu) => {
        window.open(menu.openUrl, "_blank");
    }

    const getSmallScreenMenus = () => {
        return [
            { label: 'Estate Sales', type: 'link', include: '/estate-sale/list', redirectTo: '/estate-sale/list' },
            { label: 'Explore', type: 'action', callback: openModal, dataLayer: 'explore_listing'},
            // { label: 'Categories', type: 'category-menu', include: '/category', redirectTo: '/category' },
            { label: 'Locations', type: 'link', include: '/locations', redirectTo: '/locations', dataLayer: 'locations' },
            { label: 'About Us', type: 'link', include: '/about', redirectTo: '/about', dataLayer: 'about_us' },
            { label: 'Premier Membership', type: 'link', include: '/premier-membership', redirectTo: '/premier-membership', showOrHide: validateNonMembership, dataLayer: 'premier_membership' },
            { label: 'Your Premier Membership', type: 'link', include: '/premier-membership', redirectTo: '/my-account/premier/member-benefits', showOrHide: validateMembershipCompleted, dataLayer: 'your_premier_membership' },
            { label: 'News and Stories', type: 'link', include: '/stories', redirectTo: '/stories', dataLayer: 'news_stories' },
            { label: 'Sell with Us', type: 'external-link', redirectTo: '', active: false, openUrl: 'https://www.caringtransitions.com/two-ways-to-sell', callback: onClickMenuItem, dataLayer: 'sell_ctbids' },
            // { label: 'Become our Caring Partner', type: 'external-link', redirectTo: '', active: false,  openUrl: 'https://www.caringtransitionsfranchise.com/' },
            { label: 'Sign In', type: 'action', callback: smallMenuActionCallback, showOrHide: validateNotSignedIn },
            { label: 'Register',  type: 'link', include: '/register', redirectTo: '/register', showOrHide: validateRegister   },
            {
                label: 'My Premier Benefits',
                type: 'link',
                include: '/my-account/premier',
                redirectTo: '/my-account/premier/member-benefits',
                showOrHide: validateMembershipCompleted,
                sub_menu: [
                    { label: 'Delivery Guarantee', type: 'link', include: '/delivery-guarantee', redirectTo: '/my-account/premier/delivery-guarantee' },
                    { label: `Total Access`, type: 'link', include: '/total-access', redirectTo: '/my-account/premier/total-access' },
                    { label: 'WorthPoint', type: 'link', include: '/worthpoint', redirectTo: '/my-account/premier/worthpoint' },
                    { label: 'Auction Sneak Peek', type: 'link', include: '/auction-sneak-peak', redirectTo: '/my-account/premier/auction-sneak-peak' },
                    { label: 'Premier Advisor', type: 'link', include: '/advisor', redirectTo: '/my-account/premier/advisor', },
                    { label: 'Premier Account', type: 'link', include: '/premier-account', redirectTo: '/my-account/premier/premier-account' },             
                    { label: `Alzheimer's Foundation`, type: 'link', include: '/alzheimers-foundation', redirectTo: '/my-account/premier/alzheimers-foundation' }   
                ]
            },
            {
                label: 'My Account',
                type: 'link',
                include: '/my-account/my-info',
                redirectTo: '/my-account/my-info/personal-info',
                showOrHide: validateSignedIn,
                sub_menu: [
                    { label: 'Personal Info', type: 'link', include: '/personal-info', redirectTo: '/my-account/my-info/personal-info' },
                    { label: 'Personal Interests', type: 'link', include: '/personal-interests', redirectTo: '/my-account/my-info/personal-interests' },
                    { label: 'Payment Methods', type: 'link', include: '/payment-methods', redirectTo: '/my-account/my-info/payment-methods' },
                    { label: 'Change Password', type: 'link', include: '/change-password', redirectTo: '/my-account/my-info/change-password' },
                    { label: 'Tax Exemptions', type: 'link', include: '/tax-exemptions', redirectTo: '/my-account/my-info/tax-exemptions' },
                    { label: 'Delete Your CTBids Account', type: 'link', include: '/delete-account', redirectTo: '/my-account/my-info/delete-account' }
                ]
            },
            {
                label: 'Invoices/Receipts',
                type: 'link',
                include: '/my-account/invoice',
                redirectTo: '/my-account/invoice',
                showOrHide: validateSignedIn,
                sub_menu: [
                    { label: 'Shipped Items', type: 'link', include: '/shipped-items', redirectTo: '/my-account/invoice/shipped-items' }
                ]
            },
            { label: 'Make It Returnable Status', type: 'link', include: '/my-account/mir', redirectTo: '/my-account/mir', showOrHide: validateSignedIn },
            { label: 'Delivery Guarantee Status', type: 'link', include: '/my-account/gd', redirectTo: '/my-account/gd', showOrHide: validateSignedIn },
            { label: 'Notification', type: 'link', include: '/my-account/notification-preferences', redirectTo: '/my-account/notification-preferences', showOrHide: validateSignedIn },
            // { label: 'Locations', type: 'link', include: '/locations', redirectTo: '/locations', showOrHide: validateSignedIn },
            { label: 'Watching', type: 'link', include: '/watching', redirectTo: '/watching', showOrHide: validateSignedIn, dataLayer: 'watchlist' },
            { label: 'My Bids', type: 'link', include: '/my-bids', redirectTo: '/my-bids', showOrHide: validateSignedIn, dataLayer: 'my_bids' },
            // { label: 'Won', type: 'link', include: '/my-account/won', redirectTo: '/my-account/won', showOrHide: validateSignedIn },
            // { label: 'Not Won', type: 'link', include: '/my-account/not-won', redirectTo: '/my-account/not-won', showOrHide: validateSignedIn },
            { label: 'Sign Out', type: 'action', icon: (user) => <ProfileSection props={props} user={user} />, callback: smallMenuActionCallback, showOrHide: validateSignedIn }
        ];
    };

    const getTertiaryMenus = () => {
        return [
            { id: 10, label: 'My Locations', type: 'link', redirectTo: '/my-location', active: false, dataLayer: 'location' },
            { id: 11, label: 'Watchlist', type: 'link', icon: eye, redirectTo: '/watching', active: false, dataLayer: 'watchlist' },
            { id: 12, label: 'My Bids', type: 'link', icon: hammer, redirectTo: '/my-bids', active: false, dataLayer: 'my_bids' },
        ];
    };

    const [primaryMenus, setPrimaryMenus] = useState(getPrimaryMenus());
    const [secondaryMenus, setSecondaryMenus] = useState(getSecondaryMenus());
    const [tertiaryMenus, setTertiaryMenus] = useState(getTertiaryMenus());
    const [smallScreenMenus, setSmallScreenMenus] = useState(getSmallScreenMenus());
    const [searchValue, setSearchValue] = useState('');
    const [notificationList, setNotificationList] = useState([]);

    useEffect(() => {
        if ( reduxState.user.id ) {
            sseEventListener();
        } else if ( eventSource ) {
            eventSource.close();
        }
    }, [reduxState.user.id]);

    const NotificationPopover = () => {
        const [showPopover, setShowPopover] = useState(false);
        const [pinned, setPinned] = useState(false);
    
        const bellRef = useRef(null);
        const popoverRef = useRef(null);
        let hideTimeout = useRef();
    
        useEffect(() => {
            const handleClickOutside = (event) => {
                if (
                    popoverRef.current &&
                    !popoverRef.current.contains(event.target) &&
                    bellRef.current &&
                    !bellRef.current.contains(event.target)
                ) {
                    setShowPopover(false);
                    setPinned(false);
                }
            };
    
            document.addEventListener('mousedown', handleClickOutside);
            return () => document.removeEventListener('mousedown', handleClickOutside);
        }, []);
    
        const handleMouseEnter = () => {
            clearTimeout(hideTimeout.current);
            if (!pinned) setShowPopover(true);
        };
    
        const handleMouseLeave = () => {
            if (!pinned) {
                hideTimeout.current = setTimeout(() => setShowPopover(false), 200);
            }
        };
   
        return (
            <div className='ps-3'>
            { reduxState.user.id ? 
                <>
                    <div  ref={bellRef} role="button" className={`fa-stack fa-2x ${notificationList.length === 0 ? 'fa-stack-empty' : ''}`}
                        data-count={notificationList.length}
                        style={{ width: '1.5em' }}
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave} >
                        {bell}</div>

                    <Overlay
                        target={bellRef.current}
                        show={showPopover}
                        placement="bottom-end"
                        containerPadding={10}
                    >
                        <Popover
                            id="notification-popover"
                            ref={popoverRef}
                            style={{  maxHeight: '300px', overflowY: 'auto' }}
                            onMouseEnter={() => clearTimeout(hideTimeout.current)}
                            onMouseLeave={handleMouseLeave}
                        >
                            {notificationList.length > 0 && <Popover.Body className="p-0">
                                <div>
                                    <div className="clearAll" style={{ cursor: 'pointer' }} onClick={() => updateNoticationlist(null)}>
                                        Clear All
                                    </div>
                                    {notificationList.map(res => (
                                        <div className="sec" key={res.id}>
                                            <div className="txt clickable" onClick={() => { navigateToScreen(res); setShowPopover(false); setPinned(false); }}>
                                                {res.description}
                                            </div>
                                            <div className="close" style={{ cursor: 'pointer', color: '#A50050' }} onClick={() => updateNoticationlist(res)}>
                                                {notidicationCloseIcon}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </Popover.Body>}
                        </Popover>
                    </Overlay>
                </>
             : 
                <div className='bellbutton clickable' onClick={()=>store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: 'Sign-In' } }) }>{bell}</div>
            }
        </div>
    );
};

    const navigate = (path) => {
        props.history.push(path);
    };

    const preventAndNavigate = (event, path) => {
        event.preventDefault();

        navigate(path);
    };

    const viewMoreItems = (event) => {
        event.preventDefault();
        if ( searchValue ) {
            resetBreadcrumbs();
            if (props.location.pathname.includes("view-more-items") && props.location.pathname.split('/')[2] === searchValue) {
                store.dispatch({ type: 'UPDATE_NLP_SEARCH', payload: !reduxState.nlpSearch });
            } else {
                if ( props.history.location.pathname.includes('/view-more-items') ) {
                    props.history.replace({pathname: `/view-more-items/${searchValue}`, searchValue: searchValue});
                } else {
                    props.history.push({pathname: `/view-more-items/${searchValue}`, searchValue: searchValue});
                }
            }
        }
    };

    const signInOpen = (flag) => {
        let dataLayerData = {
            'event': 'register_signin'
        }
        addDataLayer(dataLayerData);
        store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: flag } });
    };

    const registerOpen = () => {
        let dataLayerData = {
            'event': 'register'
        }
        addDataLayer(dataLayerData);
        props.history.push('/register');
    }


    /* SSE Event  */
    const sseEventListener = () => {
        try {
            const buyerId = reduxState.user.id;
            if (buyerId) {
                eventSource = new EventSource(`${getPaymentUrl(notificationSseEvent)}${buyerId}`);
                
                eventSource.onmessage = (event) => getNotificationList();
               
                eventSource.onerror = (event) => {}
            }
        } catch (e) {
            // console.error(e);
        }
    }
      /* Get Notification list data */
  
    const getNotificationList = () => {
        const data = {
            filter: [
                { field: 'status', value: 0, op: '=', join: 'AND' }
            ],
            page: {},
            sort: [
                { field: "id", direction: "desc" }
            ],
        }; 
        axios.post(getBuyersUrl(`${biddernotificationList}`), JSON.stringify(data), getBuyerHeaders()).then(response => {
            setNotificationList(response.data.data);
        });
    }

    const onNotificationClear = async (key) => {
        let data = {}
        if (key) {
              data = {
                data: {
                    status: 1,
                    id: key.id,
                    clearall: false
                }
            };
        } else {
              data = {
                data: {
                    status: 1,
                    clearall: true
                }
            };

        }
        axios.put(getBuyersUrl(updateNotication), JSON.stringify(data), getBuyerHeaders()).then(response => {
            if (response.data.status == 'success') {
                setNotificationList(notificationList.filter((item) => item.id !== key.id));
            }
        }).catch(error => {});
    };

    const navigateToScreen = (res) => {
        if (res.route === 'INVC' || res.route === 'TRAN') {
            props.history.push('/my-account/invoice/' + res.invcId + '/view');
        } else if (res.route === 'PAYMENT' || res.route === 'PYMT') {
            props.history.push('/my-account/my-info/payment-methods');
        } else if (res.route === 'ITMDETAIL' || res.route === 'MSG') {
            props.history.push('/estate-sale/' + res.saleId + '/item/' + res.itemId);
        } else if (res.route === 'WSHLIST') {
            props.history.push('/watching');
        } else if (res.route === 'BIDWON') {
            props.history.push('/my-account/won');
        }
    };

    const updateNoticationlist = async (key) => {
        let data = {}
        if (key) {
            data = {
                data: {
                    status: 1,
                    id: key.id,
                    clearall: false
                }
            };
        } else {
            data = {
                data: {
                    status: 1,
                    clearall: true
                }
            };

        }
        await axios.put(getBuyersUrl(updateNotication), JSON.stringify(data), getBuyerHeaders())
            .then(response => {
                if (response.data.status == 'success') {
                    setNotificationList(key ? notificationList.filter(item => item.id !== key.id) : []);
                }
            })
            .catch(error => {

            });
    }

    const onProfileAction = (item) => {
        switch (item.type) {
            case 'modal':
                store.dispatch({ type: 'TOGGLE_LOGOUT_MODAL', payload: true });
                break;
            default:
                break;
        }
    };

    return (
        <div className="header-main-div">
            <div className="d-flex flex-row header-box">
                <div className="d-flex flex-row align-items-center logo-box">
                    <a onClick={(event) => preventAndNavigate(event, '/')} alt="logo" className="logo-link" href="/">
                        {reduxState.user.membershipCompleted === 1 ? <img src={`${process.env.PUBLIC_URL}/static/logo/premiermember.png`} alt="CTBids Premier Member logo" className="membership-logo-image" /> : <img src={`${process.env.PUBLIC_URL}/static/logo/CTBids_logo.png`} alt="CTBids logo" className="logo-image" /> }
                    </a>
                </div>

                {/** Desktop screen toolbar */}
                <div className="d-none d-lg-flex flex-row flex-grow-1 align-items-center justify-content-between">
                    <div className="d-flex flex-row align-items-center tool-box">
                        { primaryMenus.length > 0 ? <NavigationBarHOC props={props} menus={primaryMenus} /> : null }
                        <Form className='search-box-form' onSubmit={viewMoreItems}>
                            <div className={`search-box`}>
                                <div className="input-group" style={{ marginTop: '3px', width:'360px' }}>
                                    <span className="d-flex input-group-append align-items-center clickable" style={{marginBottom: '4px', width: '15px'}}>
                                        {searchIcon}
                                    </span>
                                    <input className="form-control py-2" id="advance-sale-search-input" aria-label='Search unique treasures...' placeholder="Search unique treasures..." value={searchValue} onChange={(event) => { setSearchValue(event.target.value); }}></input>
                                </div>
                            </div>
                        </Form>
                    </div>

                    <div className='profile-box'>
                        {
                            reduxState.networkSlow ?
                            <div className="slow-network-container">
                                <OverlayTrigger
                                    trigger={['hover', 'focus']}
                                    placement="bottom-end"
                                    overlay={
                                        <Popover className="slownetwork-popover">
                                            <Popover.Body>
                                                <span>Pages may run slower over low bandwidth.</span>
                                            </Popover.Body>
                                        </Popover>
                                    }
                                >
                                    <div><i className="fas fa-wifi text-warning"></i></div>
                                </OverlayTrigger>
                            </div> : null
                        }
                        {
                            reduxState.user.id ? 
                            <div>
                                <MenuItemInput icon={<ProfileSection props={props} user={reduxState.user} />} items={profileMenuItem.items} footer={profileMenuItem.footer} onMouseLeave={(item) => { onProfileAction(item) }} onMouseEnter={(item) => { onProfileAction(item) }} onClick={(item) => { onProfileAction(item) }} />
                            </div> :
                            <div className='d-flex gap-2'>
                                <Button className='btn btn-grey' onClick={() => { signInOpen('Sign-In') }}>Sign In</Button>
                                <Button className='btn btn-secondary' onClick={() => { registerOpen() }}>Register</Button>
                            </div>
                        }
                    </div>
                </div>

                {/** Tab and mobile screen toolbar */}
                <div className='d-flex d-lg-none flex-row flex-grow-1 align-items-center justify-content-end tool-box'>
                    <div className='me-3'>
                    <SearchAccordion  props={props}  asDropdown={true}/>
                    </div>
                    <span className='me-3'>
                        {<NotificationPopover />}
                    </span>
                    <Accordion props={props} menuData={smallScreenMenus} asDropdown={true} />
                </div>
            </div>

            {/** Desktop screen menus */}
            <div className='d-none d-lg-flex header-secondary-box'>
                {secondaryMenus.length > 0 ? <NavigationBarHOC props={props} menus={secondaryMenus} menuStyling={{ fontWeight: 'normal' }} /> : null}
                <span className='d-flex align-items-center'>
                    {reduxState.user.id && tertiaryMenus.length > 0 ? <NavigationBarHOC props={props} menus={tertiaryMenus} menuStyling={{ fontWeight: 'normal' }} /> : null}
                    <span style={{marginBottom: '3px'}}>
                        {<NotificationPopover />}
                    </span>
                </span>
            </div>
        </div>
    )
};